import React from "react";
import { Button } from "devextreme-react";

/*
 * The shared chrome of the legacy operation dialogs in this folder. The Delphi forms all framed their
 * controls in TGroupBox with a caption and closed with an OK / Cancel pair at the bottom right, so the
 * border, the legend and the footer are described once here instead of once per popup.
 */

/** A captioned group box. Pass no `legend` for a box that only groups (legacy OMD0030's direction box). */
export function OperationFieldset({ legend, first, children }) {
    return (
        <fieldset
            style={{
                border: "1px solid #d3d3d3",
                borderRadius: 4,
                padding: "8px 12px",
                marginTop: first ? 0 : 10,
            }}
        >
            {legend && (
                <legend style={{ fontWeight: 600, fontSize: 13, padding: "0 6px" }}>{legend}</legend>
            )}
            {children}
        </fieldset>
    );
}

/**
 * The OK / Cancel footer. Cancel is not decoration: in Delphi it returned a modal result other than
 * mrOK, which the caller turned into an Abort, so the operation the dialog belongs to never ran.
 */
export function OperationDialogFooter({ onOk, onCancel, okText = "OK", cancelText = "Cancel", okDisabled = false }) {
    return (
        <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, paddingTop: 14 }}>
            <Button text={okText} type="default" disabled={okDisabled} onClick={onOk} />
            <Button text={cancelText} onClick={onCancel} />
        </div>
    );
}
